import { Link } from "react-router-dom";
import SideBareMagasin from "../SideBareMagasin/SideBareMagasin";
import "./commercial.css";
import { MagasinContext } from "../../../Context/MagasinContext";
import { useContext, useEffect, useState } from "react";
import { CommercialInfo } from "../../../Modeles/Commercial";
import AfficheCommercial from "../../../Services/Magasin/AfficheCommercial";
import { NewSideBarMagasins } from "../../NewSidebarMagasin";
import axios from "axios";

export interface ProductType {
  product: CommercialInfo[];
  messageErros: string;
}

export default function Commercial() {
  const magasinContext = useContext(MagasinContext);
  const [search, setSearch] = useState("");
  const MagasinId = localStorage.getItem("MagasinId");
  const id = MagasinId || magasinContext.id?.id;

  const [state, setState] = useState<ProductType>({
    product: [] as CommercialInfo[],
    messageErros: "aucun produit",
  });

  const itemsPerPage = 5;
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState<boolean>(true);
  const [activeDropdownId, setActiveDropdownId] = useState<number | null>(null);
  const [MessageSuccess, setMessageSuccess] = useState<string>("");
  const [visiblePasswordIds, setVisiblePasswordIds] = useState<Set<number>>(new Set());

  useEffect(() => {
    setLoading(true);
    AfficheCommercial(id)
      .GetCommercial()
      .then((res) => {
        setState({ ...state, product: res.data });
        setLoading(false);
      })
      .catch((msg) => {
        setState({ ...state, product: msg.messageErros });
        setLoading(false);
      });
  }, [id]);

  const handleSearch = (e: any) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  };

  const handleChangePage = (pageNumber: number) => setCurrentPage(pageNumber);

  const toggleDropdown = (id: any) => {
    setActiveDropdownId((prevId) => (prevId === id ? null : id));
  };

  const togglePasswordVisibility = (id: number) => {
    setVisiblePasswordIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };

  const HandleDeleteCommercial = async (IdCommercial: number) => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_PHP_APP_URL}/magasins/${id}/commercials/${IdCommercial}/delete`
      );
      if (response.status === 200)
        setMessageSuccess("Le commercial a bien été supprimé");
    } catch (error) {
      console.error(error);
      setMessageSuccess("Erreur lors de la suppression du commercial");
    } finally {
      setLoading(false);
    }
  };

  const { product } = state;

  const filteredProducts = (product ?? []).filter((pro) => {
    const searchTerm = search.trim().toLowerCase().replace(/\s+/g, "");
    const nom = pro.Nom ? pro.Nom.toLowerCase().replace(/\s+/g, "") : "";
    const prenom = pro.Prenom ? pro.Prenom.toLowerCase().replace(/\s+/g, "") : "";
    return nom.includes(searchTerm) || prenom.includes(searchTerm);
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredProducts.slice(indexOfFirstItem, indexOfLastItem);

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(filteredProducts.length / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* ─── MOBILE VIEW ─────────────────────────────── */
  if (screenWidth <= 450) {
    return (
      <>
        <NewSideBarMagasins />

        {loading ? (
          <div className="loader-wrapper-cmu">
            <div className="custom-spinner-cmu" role="status" />
            <span className="loader-charg-cmu">Chargement</span>
          </div>
        ) : (
          <div className="container-commercial-mobile-cmu">
            <h1 className="title-commercial-mobile-cmu">Liste des commerciaux</h1>

            {/* Search */}
            <div className="search-bar-commercial-mobile-cmu">
              <input
                type="text"
                placeholder="Chercher un commercial..."
                onChange={handleSearch}
                value={search}
              />
              <i className="bi bi-search" />
            </div>

            {/* Cards */}
            <div className="cards-commercial-mobile-cmu">
              {currentItems && currentItems.length > 0 ? (
                currentItems.map((comm: any) => (
                  <div key={comm.id || comm.IdCommercial} className="card-commercial-mobile-cmu">
                    <div className="card-header-commercial-mobile-cmu">
                      <div className="user-info-commercial-mobile-cmu">
                        <div className="dot-commercial-mobile-cmu">
                          {comm.Prenom ? comm.Prenom.charAt(0)?.toUpperCase() : (comm.Nom?.charAt(0)?.toUpperCase() || "C")}
                        </div>
                        <div className="user-details-commercial-mobile-cmu">
                          <h2>
                            {comm.Prenom} {comm.Nom}
                          </h2>
                          <p><i className="bi bi-envelope me-1" /> {comm.Email || comm.email}</p>
                          <p><i className="bi bi-telephone me-1" /> {comm.Tele || "—"}</p>
                          {comm.Cin && <p><i className="bi bi-card-text me-1" /> CIN: {comm.Cin}</p>}
                          <p><i className="bi bi-percent me-1" /> Remise: {comm.RemiseGlobal !== undefined && comm.RemiseGlobal !== null ? `${comm.RemiseGlobal}%` : "0%"}</p>
                          <p><i className="bi bi-wallet2 me-1" /> Solde: {comm.Credit ?? 0} MAD</p>
                        </div>
                      </div>
                      <i
                        className="bi bi-three-dots-vertical menu-icon-commercial-mobile-cmu"
                        onClick={() => toggleDropdown(comm.id || comm.IdCommercial)}
                      />
                      <div
                        className={`dropdown-commercial-cmu ${
                          activeDropdownId === (comm.id || comm.IdCommercial) ? "open-cmu" : ""
                        }`}
                      >
                        <Link
                          className="dropdown-item-cmu"
                          to={`/magasins/${id}/commercials/${comm.id || comm.IdCommercial}`}
                        >
                          <i className="bi bi-eye" /> Voir
                        </Link>
                        <button
                          className="dropdown-item-cmu danger-cmu"
                          onClick={() => HandleDeleteCommercial(comm.id || comm.IdCommercial)}
                          style={{
                            background: "none",
                            border: "none",
                            width: "100%",
                            textAlign: "left",
                            padding: 0,
                          }}
                        >
                          <i className="bi bi-trash3" /> Supprimer
                        </button>
                      </div>
                    </div>

                    <div className="card-footer-commercial-mobile-cmu">
                      <div className="footer-item-commercial-mobile-cmu">
                        <p className="number-commercial-mobile-cmu">{comm.Vente ?? 0}</p>
                        <p>Vendu</p>
                      </div>
                      <div className="footer-item-commercial-mobile-cmu">
                        <p className="number-commercial-mobile-cmu">{comm.Remborsé ?? 0}</p>
                        <p>Remboursé</p>
                      </div>
                      <div className="footer-item-commercial-mobile-cmu">
                        <p className="number-commercial-mobile-cmu">{comm.Annulé ?? 0}</p>
                        <p>Annulé</p>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="commercial-non-trouve-cmu">
                  <i className="bi bi-search" />
                  <h3>Aucun commercial trouvé</h3>
                  <p>Cliquez sur le bouton + pour ajouter un nouveau commercial</p>
                </div>
              )}
            </div>

            <Link to={`/magasins/${id}/commercials/add`}>
              <button className="add-button-commercial-mobile-cmu">
                <i className="bi bi-plus" />
              </button>
            </Link>
          </div>
        )}
      </>
    );
  }

  /* ─── DESKTOP VIEW ────────────────────────────── */
  return (
    <>
      <NewSideBarMagasins />
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
      />

      {loading ? (
        <div className="loader-wrapper-cmu">
          <div className="custom-spinner-cmu" role="status" />
          <span className="loader-charg-cmu">Chargement</span>
        </div>
      ) : (
        <div className="container-cmu">

          {/* Toolbar */}
          <div className="toolbar-cmu">
            <div className="search-wrapper-cmu">
              <input
                type="text"
                placeholder="Rechercher un commercial..."
                onChange={handleSearch}
                value={search}
              />
              <i className="bi bi-search search-icon-cmu" />
            </div>
            <Link to={`/magasins/${id}/commercials/add`}>
              <button className="btn-ajoute-cmu">
                <i className="bi bi-person-plus" /> Ajouter un Commercial
              </button>
            </Link>
          </div>

          <div className="table-infos-cmu">
            {MessageSuccess && (
              <div className="alert-success-cmu" style={{ margin: "16px 16px 0" }}>
                <i className="bi bi-check2-circle" /> {MessageSuccess}
              </div>
            )}

            <table className="table-cmu">
              <thead>
                <tr>
                  <th>Prénom</th>
                  <th>Nom</th>
                  <th>Email</th>
                  <th>Téléphone</th>
                  <th>CIN</th>
                  <th>Mot de passe</th>
                  <th>Remise</th>
                  <th>Solde</th>
                  <th>Vendu</th>
                  <th>En cours</th>
                  <th>Annulé</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentItems && currentItems.length > 0 ? (
                  currentItems.map((pro: any, index: number) => (
                    <tr key={index}>
                      <td style={{ fontWeight: 600 }}>{pro.Prenom || "—"}</td>
                      <td>{pro.Nom || "—"}</td>
                      <td>{pro.Email || pro.email || "—"}</td>
                      <td>{pro.Tele || "—"}</td>
                      <td>{pro.Cin || "—"}</td>

                      {/* ── Password cell with toggle ── */}
                      <td>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "8px",
                          }}
                        >
                          <span style={{ letterSpacing: "2px", fontSize: "16px" }}>
                            {visiblePasswordIds.has(pro.id || pro.IdCommercial)
                              ? pro.Password ?? pro.password ?? pro.MotDePasse ?? "—"
                              : "•".repeat(8)}
                          </span>
                          <i
                            className={`bi ${
                              visiblePasswordIds.has(pro.id || pro.IdCommercial)
                                ? "bi-eye-slash"
                                : "bi-eye"
                            }`}
                            onClick={() => togglePasswordVisibility(pro.id || pro.IdCommercial)}
                            style={{
                              cursor: "pointer",
                              color: "#6c757d",
                              fontSize: "16px",
                              flexShrink: 0,
                            }}
                            title={
                              visiblePasswordIds.has(pro.id || pro.IdCommercial)
                                ? "Masquer le mot de passe"
                                : "Afficher le mot de passe"
                            }
                          />
                        </div>
                      </td>

                      <td>{pro.RemiseGlobal !== undefined && pro.RemiseGlobal !== null ? `${pro.RemiseGlobal}%` : "0%"}</td>
                      <td style={{ fontWeight: 600 }}>{pro.Credit ?? 0} MAD</td>
                      <td className="cell-vendu-cmu">
                        {pro.Vente ?? 0} <i className="bi bi-arrow-up" />
                      </td>
                      <td className="cell-cours-cmu">{pro.EnCours ?? 0}</td>
                      <td className="cell-annule-cmu">
                        {pro.Annulé ?? 0} <i className="bi bi-arrow-down" />
                      </td>
                      <td>
                        <div className="actions-cmu">
                          <Link
                            className="btn-edit-cmu"
                            to={`/magasins/${id}/commercials/${pro.id || pro.IdCommercial}`}
                          >
                            <i className="bi bi-pencil-square" />
                          </Link>
                          <button
                            className="btn-delete-cmu"
                            onClick={() => HandleDeleteCommercial(pro.id || pro.IdCommercial)}
                          >
                            <i className="bi bi-trash3" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr className="empty-row-cmu">
                    <td colSpan={12}>
                      <i className="bi bi-inbox me-2" /> Aucun Commercial trouvé
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* Pagination */}
            {pageNumbers.length > 1 && (
              <div className="pagination-cmu">
                <button
                  onClick={() => handleChangePage(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  ← Précédent
                </button>
                {pageNumbers.map((number) => (
                  <button
                    key={number}
                    className={currentPage === number ? "active-cmu" : ""}
                    onClick={() => handleChangePage(number)}
                  >
                    {number}
                  </button>
                ))}
                <button
                  onClick={() => handleChangePage(currentPage + 1)}
                  disabled={
                    currentPage === Math.ceil(filteredProducts.length / itemsPerPage)
                  }
                >
                  Suivant →
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}